import { Button } from "antd";
import { BusinessInfoSteps } from "..";
import styles from "../../../RegisteredBusiness.module.scss";

interface IAddBusinessOwnerAction {
  handleNextStep: (_step: BusinessInfoSteps) => void;
}

const AddBusinessOwnerAction = ({
  handleNextStep,
}: IAddBusinessOwnerAction) => {
  return (
    <div className={styles.RegisteredBusinessAction}>
      <div className={styles.ActionContainer}>
        <Button
          type="primary"
          size="large"
          className={styles.ActionButton}
          onClick={() =>
            handleNextStep(BusinessInfoSteps.ADD_BUSINESS_OWNER_STEPS)
          }
        >
          Add Business Owner
        </Button>
      </div>
    </div>
  );
};

export default AddBusinessOwnerAction;
